module.exports = {"GLOBAL":"Global","THERAPEUTIC_AREA":"Therapeutic Area","DISEASE_STATE":"Disease State","DATA_SET":"Data Set","SERVE_PORTAL":"SERVE Portal"}